import { DestroyRef, Injectable } from '@angular/core';
import { pickRandom } from '@gametailors/web-core/misc';
import { LpInstance } from '../../typings/schema';
import { AudioPlayer } from '../utils/audio.utils';

@Injectable()
export class PronunciationService {
  private readonly instances: LpInstance[] = [];

  public async initialize(instances: LpInstance[]) {
    this.instances.push(...instances);
  }

  public async tryPronounce(text: string, destroyRef?: DestroyRef): Promise<void> {
    const audios = this.instances
      .flatMap((i) => {
        if (i.dataType === 'RIDKlank' && i.klank.toLowerCase() === text.toLowerCase()) {
          return i.audios.map((i) => i.audio);
        }

        if (i.dataType === 'RIDWoord' && i.woord.toLowerCase() === text.toLowerCase()) {
          return [i.audio];
        }

        // TODO: zinnen

        return [];
      })
      .filter((a) => !!a);

    if (audios.length === 0) {
      console.warn(`No audio found for '${text}', using speech synthesis as fallback.`);
      try {
        await this.speak(text, destroyRef);
      } catch (e) {
        console.error(`Speech synthesis failed for '${text}':`, e);
      }
      return;
    }

    const audio = pickRandom(audios);
    await AudioPlayer.play(audio.url);
  }

  private async speak(text: string, destroyRef?: DestroyRef): Promise<void> {
    if (typeof window === 'undefined' || !(window as typeof window & { speechSynthesis?: SpeechSynthesis }).speechSynthesis) {
      throw new Error('Speech synthesis is not supported in this environment.');
    }

    window.speechSynthesis.cancel();
    destroyRef?.onDestroy(() => window.speechSynthesis.cancel());

    await new Promise<void>((resolve) => {
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = 'nl-NL';
      utterance.rate = 0.9;
      utterance.pitch = 1;

      const cleanup = () => resolve();

      utterance.onend = cleanup;
      utterance.onerror = cleanup;

      window.speechSynthesis.speak(utterance);
    });
  }
}
